const CAREERINFO_ENDPOINTS = {
  CAREER_INFO: '/frontend/get-career-info',
  FEATURE_INFO: '/frontend/get-feature-info',
  BENEFIT_INFO: '/frontend/get-benefit-info',
};

export default CAREERINFO_ENDPOINTS;